import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from "react";

import { navigate } from "../routing/useLocationPath";

export function NavLink({
  active,
  children,
  className,
  href,
  onNavigate,
  ...props
}: {
  active: boolean;
  children: ReactNode;
  className?: string;
  href: string;
  onNavigate?: () => void;
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "children" | "onClick">) {
  function onClick(event: MouseEvent<HTMLAnchorElement>) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    navigate(href);
    onNavigate?.();
  }

  return (
    <a {...props} className={className} aria-current={active ? "page" : undefined} href={href} onClick={onClick}>
      {children}
    </a>
  );
}
